<template>
  <div class="relative min-h-screen text-gray-800 bg-white">
    <!-- Top Fade Grid Background -->
    <div
      class="fixed inset-0 z-0 pointer-events-none"
      :style="{
        backgroundImage: `
        linear-gradient(to right, #e2e8f0 1px, transparent 1px),
        linear-gradient(to bottom, #e2e8f0 1px, transparent 1px)
      `,
        backgroundSize: '40px 60px',
        WebkitMaskImage:
          'radial-gradient(ellipse 70% 60% at 50% 100%, #000 40%, transparent 100%)',
        maskImage:
          'radial-gradient(ellipse 70% 60% at 50% 100%, #000 40%, transparent 100%)',
      }"
    ></div>
    <!-- Content Container -->
    <div class="relative z-10 flex flex-col min-h-screen">
      <RNavBar />
      <main class="flex-1">
        <slot></slot>
      </main>
    </div>
  </div>
</template>
